(() => {
 const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(c/100);
 const el=(tag,cls,text)=>{const n=document.createElement(tag);n.className=cls;if(text)n.textContent=text;return n;};
 let busy=false;
 function render(){
  document.querySelectorAll('.order-summary__body,.cart-drawer__items').forEach(container=>{
   if(container.dataset.tmGrouped)return;
   const lines=[...container.querySelectorAll('line-item[data-tm-cart-key]')].map(node=>({node,key:node.dataset.tmCartKey,title:node.dataset.tmCartTitle,qty:Number(node.dataset.tmCartQuantity),price:Number(node.dataset.tmCartPrice),p:Object.fromEntries(JSON.parse(node.dataset.tmCartProperties||'[]'))}));
   if(!lines.length)return;
   container.dataset.tmGrouped='yes';
   const parents=lines.filter(x=>x.p._tm_role==='mailbox'||(!x.p._tm_group&&x.p['LED House Numbers']));
   parents.forEach(parent=>{
    const children=lines.filter(x=>{
     if(x===parent)return false;
     if(parent.p._tm_group)return x.p._tm_group===parent.p._tm_group&&x.p._tm_role==='upgrade';
     if(x.p._tm_group||x.p.Mailbox!==parent.title||x.p.Address!==parent.p['House Numbers'])return false;
     return parents.filter(p=>p.title===x.p.Mailbox&&p.p['House Numbers']===x.p.Address).length===1&&/LED|power kit|transformer/i.test(x.title);
    });
    if(!children.length||children.some(c=>!Number.isInteger(c.qty/parent.qty)))return;
    const row=parent.node.closest('tr')||parent.node;
    row.classList.add('tm-cart-group');
    const info=parent.node.querySelector('.line-item-info');
    const title=info.querySelector('a');if(title)title.classList.add('tm-cart-group__title');
    const old=info.querySelector('[data-tm-cart-details]');
    if(old){
      const specs=el('dl','tm-cart-group__specs');
      const ledPaid=children.some(c=>/per digit/i.test(c.title));
      const powerPaid=children.some(c=>/transformer|hardwired|solar/i.test(c.title));
      [...old.querySelectorAll('p,li')].forEach(n=>{
        const text=n.textContent.trim();if(!text)return;
        const colon=text.indexOf(':'),key=colon<0?'Finish':text.slice(0,colon).trim(),value=colon<0?text:text.slice(colon+1).trim();
        if(ledPaid&&['LED House Numbers','LED Placement','LED Temperature'].includes(key))return;
        if(powerPaid&&key==='LED Power Source')return;
        specs.append(el('dt','',key),el('dd','',value));
      });
      old.replaceWith(specs);
    }
    const upgrades=el('div','tm-cart-group__upgrades');
    children.sort((a,b)=>Number(/per digit/i.test(b.title))-Number(/per digit/i.test(a.title))).forEach(child=>{
     const childRow=child.node.closest('tr')||child.node;childRow.hidden=true;childRow.classList.add('tm-cart-group__hidden');
     const item=el('div','tm-cart-group__upgrade');
     let label=child.title;
     if(/per digit/i.test(label)){
      let placement=parent.p['LED Placement']||child.p.Placement||'';
      if(/Bradley|Thumbs Up/i.test(parent.title)&&placement==='Single set')placement='Front trim';
      label='LED house numbers · '+(child.qty/parent.qty)+' digits'+(placement?' · '+placement:'')+(parent.p['LED Temperature']?' · '+parent.p['LED Temperature']:'');
     }else if(/hardwired|transformer/i.test(label))label='12V transformer';
     else if(/solar/i.test(label))label='Solar power kit';
     item.append(el('span','',label),el('strong','',money(child.price)));upgrades.append(item);
    });
    const total=parent.price+children.reduce((sum,c)=>sum+c.price,0);
    const subtotal=el('div','tm-cart-group__subtotal');subtotal.append(el('span','','Configured total'),el('strong','',money(total)));upgrades.append(subtotal);
    info.append(upgrades);
    if(row.tagName==='TR')row.lastElementChild.textContent=money(total);
    row.querySelectorAll('line-item-quantity').forEach(n=>n.hidden=true);
    const controls=el('div','tm-cart-group__controls');
    const minus=el('button','','−'),plus=el('button','','+'),quantity=el('span','',String(parent.qty)),remove=el('button','tm-cart-group__remove','Remove mailbox & upgrades');
    [minus,plus,remove].forEach(n=>n.type='button');
    minus.setAttribute('aria-label','Decrease '+parent.title+' quantity');plus.setAttribute('aria-label','Increase '+parent.title+' quantity');minus.disabled=parent.qty<=1;
    const status=el('p','tm-cart-group__status');status.setAttribute('role','status');
    async function update(q){
     if(busy)return;busy=true;controls.querySelectorAll('button').forEach(n=>n.disabled=true);status.textContent='Updating mailbox and upgrades…';
     try{
      const root=window.Shopify?.routes?.root||'/';
      const currentResponse=await fetch(root+'cart.js');if(!currentResponse.ok)throw Error('Could not check cart.');
      const current=await currentResponse.json();
      const members=[parent,...children];
      if(members.some(m=>!current.items.some(i=>i.key===m.key&&i.quantity===m.qty)))throw Error('Your cart changed. Refresh the page before updating.');
      const updates={};members.forEach(m=>updates[m.key]=q*(m.qty/parent.qty));
      const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      const result=await response.json();if(!response.ok||result.status)throw Error(result.description||'Could not update cart.');
      location.reload();
     }catch(error){status.textContent=error.message;busy=false;controls.querySelectorAll('button').forEach(n=>n.disabled=false);minus.disabled=parent.qty<=1;}
    }
    minus.addEventListener('click',()=>update(parent.qty-1));plus.addEventListener('click',()=>update(parent.qty+1));remove.addEventListener('click',()=>update(0));
    controls.append(minus,quantity,plus,remove);info.append(controls,status);
   });
  });
 }
 render();let queued=false;
 new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;render();});}).observe(document.body,{childList:true,subtree:true});
})();